import { CircleDashed } from "lucide-react";

import { V2OutputRow } from "@/components/Spotflow/WorkflowRunner/Outputs/V2OutputRow";
import type { IterationPage } from "@/components/Spotflow/WorkflowRunner/Outputs/v2FanOut";

/** What a fan-out iteration page shows in place of its output rows when the
 *  item did not succeed: the item's own error, or that it never started. */
export function IterationOutcomeRows({
  page,
  nodeId,
  firstFailed,
}: {
  page: Exclude<IterationPage, { kind: "ok" }>;
  nodeId?: string;
  firstFailed: number | null;
}) {
  if (page.kind === "failed") {
    return (
      <V2OutputRow
        nodeId={nodeId}
        label="_error"
        value={page.error}
        type="str"
        isError
      />
    );
  }
  return (
    <div
      role="status"
      className="flex w-full items-center gap-2 rounded-lg border border-dashed border-border/70 bg-muted/20 px-3 py-2.5 text-sm text-muted-foreground"
    >
      <CircleDashed className="size-4 shrink-0" />
      <span>
        Not run
        {firstFailed !== null
          ? `. The node stopped after iteration ${firstFailed} failed.`
          : "."}
      </span>
    </div>
  );
}
